import React, { FC } from 'react';
import Form from 'components/Form';

import { SbpprotegePageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Sbpprotege: FC<SbpprotegePageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Sbpprotege;
